import { createAsyncThunk } from "@reduxjs/toolkit";
import asyncInstance from "config/AsyncInstance";
import apiInstance from "config/axiosInstance";

export const GetAllRoleType = createAsyncThunk(
  "empolyee/GetAllRoleType",
  async (_, { rejectWithValue }) => {
    try {
      const response = await asyncInstance.get(`roletypeView`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);
export const GetAllPermissionType = createAsyncThunk(
  "empolyee/GetAllPermissionType",
  async (body, { rejectWithValue }) => {
    try {
      const response = await apiInstance.get(`rolemanageView/${body}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const EditPermissionRole = createAsyncThunk(
  "empolyee/EditPermissionRole",
  async (body, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post(`rolemanageCreate`, body);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);
